module.exports = __webpack_public_path__ + "media/images/subscribe-icon-monthly-7f3a4897.svg";